import { EOriginSystemId } from '@if/core/types'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import ContractInformation from './ContractInformation'
import DownloadContractButton from './DownloadContractButton'

interface Props {
  creditApp: CreditApplication
}
const ContractCompleted = ({ creditApp }: Props) => {
  return (
    <>
      <ContractInformation creditApp={creditApp} />
      {creditApp.originSystemId === EOriginSystemId.MerchantDashboard && (
        <DownloadContractButton creditApp={creditApp} />
      )}
    </>
  )
}

export default ContractCompleted
